var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.469,
    height: 16.909,
    viewBox: "0 0 12.469 16.909",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20553",
    "data-name": "Group 20553",
    transform: "translate(-14.4 -8.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Unlock",
    transform: "translate(14.4 8.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-70",
    d: "M-315.134-414.482H-316.2v-2.273a5.064,5.064,0,0,1,5.044-5.044,4.83,4.83,0,0,1,4.044,2.124c.8,1.29.813,3.509.969,4.742h-.969c-.122-.977.162-2.715-.849-4.165a3.5,3.5,0,0,0-3.195-1.635,3.972,3.972,0,0,0-3.979,3.979v2.273",
    transform: "translate(317.408 421.8)",
    fill: "#142e38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-71",
    d: "M-308.836-392.7h-9.058a1.705,1.705,0,0,1-1.705-1.705v-6.785a1.706,1.706,0,0,1,1.705-1.705h9.058a1.705,1.705,0,0,1,1.705,1.705v6.785a1.683,1.683,0,0,1-1.705,1.705Zm-9.023-9.023a.561.561,0,0,0-.568.568v6.785a.561.561,0,0,0,.568.568h9.058a.561.561,0,0,0,.568-.568v-6.785a.561.561,0,0,0-.568-.568Z",
    transform: "translate(319.6 409.614)",
    fill: "#142e38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-72",
    d: "M-302.927-395.363a1.122,1.122,0,0,1-1.137,1.137,1.122,1.122,0,0,1-1.137-1.137,1.122,1.122,0,0,1,1.137-1.137,1.145,1.145,0,0,1,1.137,1.137",
    transform: "translate(310.315 405.487)",
    fill: "#142e38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-73",
    d: "M-303.263-393.3h-.568l-.568,3.41h1.705l-.568-3.41",
    transform: "translate(309.8 403.424)",
    fill: "#142e38"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.0d321b00f7523ac541570ccfca74ca66.svg";
export { ForwardRef as ReactComponent };